import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import { Empty, message, Result, Table } from 'antd'

import { ratesTableReport } from '../../services'
import { handleError, number } from '../../../../helpers'

export default function RatesTableTab({ reports, setReports, filters, activeKey, setLoading }) {
    const [currentParams, setCurrentParams] = useState(null)
    
    useEffect(() => {
        if(activeKey === 'rates_table' && (!reports || !reports.rates_table) && filters.sent_at_from){
            ratesTableReport(filters)
                .then(res => {
                    message.success(res.data.message)
                    setReports({ ...reports, rates_table: res.data.data })
                    setCurrentParams(res.data.params)                    
                })
                .catch(error => handleError(error))
                .finally(() => setLoading(false))
        }
    }, [ filters, activeKey, reports, setReports, setLoading ])

    if(!filters.sent_at_from)
        return <Empty description="Debe generar el reporte primero" />

    if(!reports || !reports.rates_table)
        return <Spinner animation='border' size='sm' />

    const columns = [
        {
            title: 'Código Tarifa',
            dataIndex: 'rate',
            render: t => t
        },
        {
            title: 'Facturas',
            dataIndex: 'total_invoices',
            render: t => number(t)
        },
        {
            title: 'Tiendas',
            dataIndex: 'total_stores',
            render: t => number(t)
        },
        {
            title: 'Valor Ventas',
            dataIndex: 'total_value',
            render: t => `$ ${number(t)} COP`
        },
        {
            title: 'Unidades',
            dataIndex: 'total_quantity',
            render: t => number(t)
        },
    ]

    return (
        <React.Fragment>
            <div className='bg-light py-5 px-15 mb-10'>
                <em>Reporte generado para campañas <b>con facturas sincronizadas</b> con fecha de envió entre <b>{currentParams.sent_at_from}</b> y <b>{currentParams.sent_at_until}</b> {currentParams.store_code && ` Y facturas de tienda cuyo codigo contenga: ${currentParams.store_code}`}</em>.
            </div>
            
            <Table
                columns={columns}
                dataSource={reports.rates_table.rates}
                rowKey={r => r.id}
                locale={{ emptyText: <Result title="No se encontro resultados" status="404" /> }}
                size="small"
            />

            <div className='mt-10'>
                <small>Campañas analizadas: {reports.rates_table.campaign_ids.join(', ')}</small>
            </div>
        </React.Fragment>
    )
}